import { ClientBriefDto } from './Client'
import { EntityDtoBase, PaymentState, IdNameDto } from './Common'

export interface InvoiceIssuerBriefDto extends EntityDtoBase {
    name: string
    bankAccount: string
    iban: string
    swift: string
    paymentDays: number
    address: string
    companyRegistrationNumber: string
    valueAddedTaxIdentificationNumber: string
    invoicedBy: string
}

export interface InvoiceIssuerDto extends InvoiceIssuerBriefDto {
    imageName: string
    imageData: Uint8Array
    invoicedLast12Months: number
}

export interface InvoiceDto extends EntityDtoBase {
    paymentState: PaymentState
    issueDate: Date
    dueDate: Date
    taxDate: Date
    invoiceNumber: number
    invoicedWithoutTax: number
    subject: string
    invoiceIssuer: InvoiceIssuerDto
    client: ClientBriefDto
    productsText: string
    paymentType: InvoicePaymentType
    orderNumber?: string
}

export interface InvoiceBriefDto extends EntityDtoBase {
    invoiceNumber: number
    invoicedWithoutTax: number
    issueDate: Date
    dueDate: Date
    eventIdName: IdNameDto
    issuerName: string
    clientName: string
    paymentState: PaymentState
    productsText: string
    paymentType: InvoicePaymentType
    orderNumber?: string
}

export enum InvoicePaymentType {
    NotSet = 0,
    WireTransfer = 1,
    Cash = 2,
}

export interface CreateInvoiceIssuerDto extends Omit<InvoiceIssuerBriefDto, 'id' | 'createdAt' | 'lastModifiedBy'> {}
